import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
// import OverallScore from './OverallScore'
import useSetupProgress from '@forwardflow/hooks/customHooks/onboarding/useSetupProgress'
import useGetAnalyticsData from '@forwardflow/hooks/customHooks/marketing/useGetAnalyticsData'
import OutreachPerformance from './OutreachPerformance'
import OverviewCards from './OverviewCards'
import SalesPipelineHealth from './SalesPipelineHealth'
import TopLeadSource from './TopLeadSource'
import {
   sampleSalesPipelineData,
} from './data'

const antIcon = <LoadingOutlined style={{ fontSize: 24, color: '#8B5CF6' }} spin />

const MarketingPage = () => {
   const { data: progressDetails, isLoading: progressLoading } = useSetupProgress()
   const { isLoading: analyticsLoading } = useGetAnalyticsData()

   // Show spinner while loading
   if (progressLoading || analyticsLoading) {
      return (
         <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
               <Spin indicator={antIcon} size="large" />
               <p className="mt-4 text-gray-400">Loading your performance data...</p>
            </div>
         </div>
      )
   }

   return (
      <>
         <div className="mx-auto px-[15%] pt-5">
            <div className="mb-10">
               <div className="flex items-center gap-3 mb-4">
                  <div className="w-2 h-8 rounded-full bg-gradient-to-b from-primary to-primary/60"></div>
                  <p className="text-sm font-semibold tracking-wider uppercase text-primary">
                     WELCOME{' '}
                     {progressDetails?.businessDetails?.friendlyBusinessName}!
                  </p>
               </div>
               <h1 className="text-4xl font-bold leading-tight text-white">
                  Here's your overall performance
               </h1>
            </div>
            <OverviewCards />
            <div className="mt-8">
               <div className="px-6 py-4 mb-4 text-white rounded-lg bg-primary-dark">
                  <h2 className="text-lg font-medium">Report Details</h2>
               </div>

               <OutreachPerformance/>
            </div>
            <div className="mt-8">
               <SalesPipelineHealth data={sampleSalesPipelineData} />
            </div>
            <div className="mt-8">
               <TopLeadSource />
            </div>
         </div>
      </>
   )
}

export default MarketingPage